document.addEventListener("DOMContentLoaded", () => {

    /* ===========================
       GALERIE
    =========================== */

    const mainImage = document.querySelector(".premium-main-image");
    const thumbs = document.querySelectorAll(".premium-thumb");

    thumbs.forEach((thumb) => {

        thumb.addEventListener("click", () => {

            thumbs.forEach(t => t.classList.remove("active"));

            thumb.classList.add("active");

            const image = thumb.dataset.image;

            if (mainImage) {
                mainImage.src = image;
            }

        });

    });


    /* ===========================
       QUANTITÉ
    =========================== */

    const qtyInput = document.querySelector('.premium-quantity input');

    if(qtyInput){

        const minus = document.querySelector('.premium-quantity button:first-child');
        const plus = document.querySelector('.premium-quantity button:last-child');

        minus.addEventListener('click',()=>{

            let value = parseInt(qtyInput.value);

            if(value > 1){

                qtyInput.value = value - 1;

            }

        });

        plus.addEventListener('click',()=>{

            let value = parseInt(qtyInput.value);

            qtyInput.value = value + 1;

        });

    }


    /* ===========================
       BOUTONS DE TAILLE
    =========================== */

/* ===========================
   SHOPIFY VARIANTS
=========================== */

const variantData = document.getElementById("ProductVariants");

if (variantData) {

    const variants = JSON.parse(variantData.textContent);

    const buttons = document.querySelectorAll(".premium-value");

    const variantInput = document.getElementById("PremiumVariantInput");

    const price = document.querySelector(".premium-price");

    const image = document.querySelector(".premium-main-image");

    let selectedOptions = [];

    document.querySelectorAll(".premium-option").forEach((group,index)=>{

        const active = group.querySelector(".premium-value.active");

        if(active){

            selectedOptions[index] = active.dataset.optionValue;

        }

    });

    buttons.forEach(button=>{

        button.addEventListener("click",()=>{

            const option = Number(button.dataset.optionPosition)-1;

            selectedOptions[option]=button.dataset.optionValue;

            document
            .querySelectorAll(
                `[data-option-position="${button.dataset.optionPosition}"]`
            )
            .forEach(btn=>btn.classList.remove("active"));

            button.classList.add("active");

            const variant = variants.find(v=>{

                return v.options.every((opt,index)=>{

                    return opt===selectedOptions[index];

                });

            });

            if(!variant) return;

            variantInput.value = variant.id;

            if(price){

                price.innerHTML = Shopify.formatMoney(
                    variant.price,
                    window.Shopify.money_format
                );

            }

            if(image && variant.featured_image){

                image.src = variant.featured_image.src;

            }

        });

    });

}


    /* ===========================
       ANIMATION
    =========================== */

    const animated = document.querySelectorAll(
        ".premium-gallery, .premium-info, .premium-faq"
    );

    animated.forEach((el,index)=>{

        el.style.opacity="0";
        el.style.transform="translateY(30px)";
        el.style.transition="0.6s ease";

        setTimeout(()=>{

            el.style.opacity="1";
            el.style.transform="translateY(0)";

        },150 * index);

    });

});